import { apiSlice } from "./apiSlice";
import { CHAPTER_URL } from "../constants";

export const chapterApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create chapter
    createChapter: builder.mutation({
      query: (data) => ({
        url: CHAPTER_URL,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["Chapter"],
    }),

    // Get all chapters
    getChapters: builder.query({
      query: () => ({
        url: CHAPTER_URL,
      }),

      providesTags: ["Chapter"],

      keepUnusedDataFor: 5,
    }),

    // Get chapter details
    getChapterDetails: builder.query({
      query: (id) => ({
        url: `${CHAPTER_URL}/${id}`,
      }),

      providesTags: ["Chapter"],

      keepUnusedDataFor: 5,
    }),
// Get chapters by subject
getChaptersBySubject: builder.query({
  query: (subjectId) => ({
    url: `${CHAPTER_URL}/subject/${subjectId}`,
  }),

  providesTags: ["Chapter"],

  keepUnusedDataFor: 5,
}),
    // Update chapter
    updateChapter: builder.mutation({
      query: (data) => ({
        url: `${CHAPTER_URL}/${data.chapterId}`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["Chapter"],
    }),

    // Delete chapter
    deleteChapter: builder.mutation({
      query: (id) => ({
        url: `${CHAPTER_URL}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: ["Chapter"],
    }),
  }),
});

export const {
  useCreateChapterMutation,
  useGetChaptersQuery,
  useGetChapterDetailsQuery,
  useGetChaptersBySubjectQuery,
  useUpdateChapterMutation,
  useDeleteChapterMutation,
} = chapterApiSlice;